module.exports = __webpack_public_path__ + "img/Banco-GNB.4e91b064.svg";